export const VIEW_API_BASE_URL = `${process.env.REACT_APP_JELLYVIEW_API}`;
export const VIEW_MASTER_API_BASE_URL = `${process.env.REACT_APP_MASTER_API}`;
export const VIEW_CUSTOM_API_BASE_URL = process.env.REACT_APP_MASTER_API;
